@file:OptIn(InternalResourceApi::class)

package liquid_root.samples.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DensityQualifier
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/liquid_root.samples.shared.generated.resources/"

@delegate:ResourceContentHash(-344_862_228)
public val Res.drawable.dotonbori: DrawableResource by lazy {
      DrawableResource("drawable:dotonbori", setOf(
        ResourceItem(setOf(), "${MD}drawable/dotonbori.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-117_966_310)
public val Res.drawable.moon_and_stars: DrawableResource by lazy {
      DrawableResource("drawable:moon_and_stars", setOf(
        ResourceItem(setOf(), "${MD}drawable/moon_and_stars.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_788_368_616)
public val Res.drawable.northern_lights: DrawableResource by lazy {
      DrawableResource("drawable:northern_lights", setOf(
        ResourceItem(setOf(), "${MD}drawable/northern_lights.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_428_836_590)
public val Res.drawable.ny_city: DrawableResource by lazy {
      DrawableResource("drawable:ny_city", setOf(
        ResourceItem(setOf(), "${MD}drawable/ny_city.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-222_067_337)
public val Res.drawable.prague_clock: DrawableResource by lazy {
      DrawableResource("drawable:prague_clock", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/prague_clock.webp", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/prague_clock.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("dotonbori", Res.drawable.dotonbori)
  map.put("moon_and_stars", Res.drawable.moon_and_stars)
  map.put("northern_lights", Res.drawable.northern_lights)
  map.put("ny_city", Res.drawable.ny_city)
  map.put("prague_clock", Res.drawable.prague_clock)
}
